var Touch = (function () {
    function Touch() {
    }
    return Touch;
}());
export { Touch };
